import React, {useState} from 'react';
import {connect} from 'react-redux';
import DeleteUserModal from './modals/DeleteUserModal';
import EditUserModal from './modals/EditUserModal';
import AssignAlertsModal from './modals/AssignAlertsModal';
import AssignNudgeEmailsModal from './modals/AssignNudgeEmailsModal';
import Tooltip from 'components/Tooltip';
import './style.scss';

const UserListItem = (props) => {
    const {
        item, refreshList, showNudgeColumn, hasNudgePermissions,
        savedSearches, entitiesLoading, fullEntitiesList, auth,
    } = props;
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [hourlyAssignModalOpen, setHourlyAssignModalOpen] = useState(false);
    const [dailyAssignModalOpen, setDailyAssignModalOpen] = useState(false);
    const [nudgeAssignModalOpen, setNudgeAssignModalOpen] = useState(false);

    // const updateDailyAlertsToggle = (updatedUserId, selectedItems) => {
    //     updateDailyAlerts(updatedUserId, selectedItems);
    //     // setDailyAssignModalOpen(false);
    // };
    //
    // const updateHourlyAlertsToggle = (updatedUserId, selectedItems) => {
    //     updateRTAlerts(updatedUserId, selectedItems);
    //     // setHourlyAssignModalOpen(false);
    // };

    return (
        <tr className="table_row">
            {deleteModalOpen && (
                <DeleteUserModal
                    isOpen={deleteModalOpen}
                    toggle={() => setDeleteModalOpen(prevState => !prevState)}
                    user={item}
                    refreshList={refreshList}
                />
            )}
            {editModalOpen && (
                <EditUserModal
                    isOpen={editModalOpen}
                    toggle={() => setEditModalOpen(prevState => !prevState)}
                    user={item}
                    refreshList={refreshList}
                    disableAdminSelection={auth.username === item.email}
                />
            )}
            {dailyAssignModalOpen && (
                <AssignAlertsModal
                    isOpen={dailyAssignModalOpen}
                    toggle={() => setDailyAssignModalOpen(prevState => !prevState)}
                    user={item}
                    fullList={savedSearches}
                    selectedList={item.dailyAlerts ? item.dailyAlerts : []}
                    refreshList={refreshList}
                    alertType="daily"
                />
            )}
            {hourlyAssignModalOpen && (
                <AssignAlertsModal
                    isOpen={hourlyAssignModalOpen}
                    toggle={() => setHourlyAssignModalOpen(prevState => !prevState)}
                    user={item}
                    fullList={savedSearches}
                    selectedList={item.hourlyAlerts ? item.hourlyAlerts : []}
                    refreshList={refreshList}
                    alertType="hourly"
                />
            )}
            {setNudgeAssignModalOpen && (
                <AssignNudgeEmailsModal
                    isOpen={nudgeAssignModalOpen}
                    toggle={() => setNudgeAssignModalOpen(prevState => !prevState)}
                    user={item}
                    fullList={fullEntitiesList}
                    entitiesLoading={entitiesLoading}
                    selectedList={item.nudgeAlerts ? item.nudgeAlerts : []}
                    refreshList={refreshList}
                    // alertType="hourly"
                />
            )}
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Name</strong>
                <div className="table-title_container">
                    <span id={`title-${item.id}`}>{item.name}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Email</strong>
                <div className="table-title_container">
                    <span id={`title-${item.id}`}>{item.email}</span>
                </div>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Admin</strong>
                <span id={`title-${item.id}`}>{item.isAdministrator ? <i className="fas fa-check"/> : ''}</span>
            </td>
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Confirmed</strong>
                <span id={`title-${item.id}`}>{item.enabled ? <i className="fas fa-check"/> : ''}</span>
            </td>
            {auth.permissions && auth.permissions.includes('search') &&
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Daily Digest</strong>
                {item.enabled &&
                <Tooltip placement="bottom" tooltip="Subscribe for daily alerts">
                    <i
                        style={{fontSize: '20px', cursor: 'pointer'}}
                        className={`${(item.dailyAlerts && item.dailyAlerts.length > 0) ? 'fas' : 'far'} fa-envelope search_page-icon`}
                        id={`alert-${item.id}`}
                        onClick={() => setDailyAssignModalOpen(true)}
                    />
                </Tooltip>
                }
            </td>
            }
            {auth.permissions && auth.permissions.includes('search') &&
            <td className="table_column" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Real Time Alerts</strong>
                {item.enabled &&
                <Tooltip placement="bottom" tooltip="Subscribe for real time alerts">
                    <i
                        style={{fontSize: '20px', cursor: 'pointer'}}
                        // className={`${item.assignedRTSearches.length > 0 ? 'fas' : 'far'} fa-clock search_page-icon`}
                        className={`${(item.hourlyAlerts && item.hourlyAlerts.length > 0) ? 'fas' : 'far'} fa-clock search_page-icon`}
                        id={`alert-${item.id}`}
                        onClick={() => setHourlyAssignModalOpen(true)}
                    />
                </Tooltip>
                }
            </td>
            }
            {showNudgeColumn &&
            (hasNudgePermissions ?
                    <td className="table_column" style={{verticalAlign: 'middle'}}>
                        <strong className="table_lable">Nudge Email</strong>
                        <Tooltip placement="bottom" tooltip="Subscribe for real time alerts">
                            <i
                                style={{fontSize: '20px', cursor: 'pointer'}}
                                // className={`${item.assignedRTSearches.length > 0 ? 'fas' : 'far'} fa-clock search_page-icon`}
                                className={`${(item.nudgeAlerts && item.nudgeAlerts.length > 0) ? 'fas' : 'far'} fa-envelope search_page-icon`}
                                id={`alert-${item.id}`}
                                onClick={() => setNudgeAssignModalOpen(true)}
                            />
                        </Tooltip>
                    </td>
                    :
                    <td/>
            )}
            <td className="table_column column_action" style={{verticalAlign: 'middle'}}>
                <strong className="table_lable">Actions</strong>
                <div style={{width: '60px', display: 'flex'}}>
                    <Tooltip placement="bottom" tooltip="Edit">
                        <i
                            onClick={() => setEditModalOpen(prevState => !prevState)}
                            className="feedsActions mr-2 fas fa-pencil-alt"
                        />
                    </Tooltip>
                    {auth.username !== item.email &&
                    <Tooltip placement="bottom" tooltip="Delete">
                        <i
                            onClick={() => setDeleteModalOpen(prevState => !prevState)}
                            className="feedsActions fas fa-trash-alt"
                        />
                    </Tooltip>
                    }
                </div>
            </td>
        </tr>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(UserListItem);
